module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/21-23d83e60f586bb41a0c6312610e5aafc.png";